import { render, staticRenderFns } from "./AppLoginForm.vue?vue&type=template&id=a2879208&scoped=true&"
import script from "./AppLoginForm.vue?vue&type=script&lang=js&"
export * from "./AppLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./AppLoginForm.vue?vue&type=style&index=0&id=a2879208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2879208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
